import { render, staticRenderFns } from "./SituationList.vue?vue&type=template&id=89c08df4"
import script from "./SituationList.vue?vue&type=script&lang=js"
export * from "./SituationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports